
import { convertSec2Str, initCreateFn } from "@/utils/util";
import { ImagePreview, Dialog } from "vant";
import {
  defineComponent,
  nextTick,
  onBeforeUnmount,
  reactive,
  Ref,
  ref,
  toRefs,
} from "vue";
import { useRoute, useRouter } from "vue-router";
import {
  farmerChatDetailApi,
  replyChatApi,
  updateZanApi,
  delCommentApi,
} from "../../../api/farmerSpace";
import { StateType } from "./infoDetail";
import PreviewVideo from "@/components/previewVideo/previewVideo.vue";
import Storage from "@/storage/Storage";
function getState(): StateType {
  return {
    detailData: {},
    replyPlaceholder: "评论...",
    showReply: false,
    videoUrl: "",
    previewVideo: false,
    replyMessage: "",
    replyData: {},
    recordId: "",
    comId: "",
    timer: {},
    delId: "",
    acDelId:"",
    is1S:false
  };
}
export default defineComponent({
  components: {
    PreviewVideo,
  },
  setup() {
    const state = reactive<StateType>(getState());
    const route = useRoute();
    const router = useRouter();
    const replyField = ref();
    const { getDetailData, onConfirmReply, onZan, onComment } = useDatas(
      state,
      replyField
    );

    nextTick(() => {
      getDetailData(route.params.id as string);
      state.recordId = route.params.id as string;
    });

    // 监听document点击事件，当数据点赞菜单弹出的情况下，实现点击其他地方关闭该菜单
    document.onclick = function (e) {
      // 只有在当前页面下才去执行，因为监听的是document，如果不判断，则会影响其他页面
      if (/(\/infoDetail\/[0-9]+)/.test(route.path)) {
        (state.detailData as { isShow: boolean }).isShow = false;
        state.comId =state.acDelId =  "";
            state.is1S = false
        // 点击到其他空白处的时候回复框也重置
        if (!state.replyMessage) {
          state.replyPlaceholder = "评论...";
          state.replyData = {};
        }
      }
    };

    // 当数据中的评论多了以后，也会触发滚动，所以也要关闭一下
    document.onscroll = function () {
      // 在当前页面下
      if (
        /(\/infoDetail\/[0-9]+)/.test(route.path) &&
        (state.detailData as { isShow: boolean }).isShow
      ) {
        (state.detailData as { isShow: boolean }).isShow = false;
      }
    };

    onBeforeUnmount(() => {
      // 退出该页面时，将编辑过后的数据同步到临时的缓存数据中
      let tempData = Storage.get("tempSpaceData");
      if (tempData && Object.keys(tempData).length > 0) {
        // 在数组中找到那条数据并替换掉
        const tempIndex = tempData.datas.findIndex(
          (item: any) => +item.id === (state.detailData as { id: number }).id
        );
        console.log(tempIndex);
        console.log("tempData", tempData);
        if (tempIndex != -1) {
          (state.detailData as { curPage: number }).curPage =
            tempData.datas[tempIndex].curPage;
          tempData.datas.splice(tempIndex, 1, state.detailData);
          Storage.remove("tempSpaceData");
          Storage.add("tempSpaceData", tempData);
        }
      }
    });

    return {
      replyField,
      ...toRefs(state),
      ...useOper(state),
      ...useEvents(state, replyField, router),
      onConfirmReply,
      onZan,
      onComment,
      initCreateFn,
      getDetailData,
    };
  },
});

const useEvents = (state: StateType, replyField: Ref, router: any) => {
  return {
    onReplyBlur: function () {
      let timer = setTimeout(() => {
        clearTimeout(timer);
        state.showReply = false;
        state.replyMessage = "";
      }, 600);
    },
    onShow: function () {
      (state.detailData as { isShow: boolean }).isShow = !(
        state.detailData as { isShow: boolean }
      ).isShow;
    },
    onPreviewVideo: function (url: string) {
      state.videoUrl = url;
      state.previewVideo = true;
    },
    onPreviewImg: function (index: number) {
      ImagePreview({
        images: (state.detailData as { imgList: any }).imgList.map(
          (item: any) => item.url
        ),
        startPosition: index,
      });
    },
    onClickReply: function (item: any) {
      state.showReply = true;
      state.acDelId = ''
            state.is1S = false
      // 保存一下回复的评论数据
      state.replyData = item;
      nextTick(() => {
        state.replyPlaceholder = "回复 " + item.name;
        replyField.value.focus();
      });
    },
    // 触摸开始
    touchStart: (comId: string, canDel: boolean) => {
      if (!canDel) {
        return;
      }
      state.acDelId =comId
      clearTimeout(state.timer);
      state.timer = setTimeout(() => {
        state.delId = state.comId =comId;
        state.is1S = true
      }, 1000);
    },
    // 触摸结束
    touchEnd: () => {
      if(!state.is1S){
        state.acDelId = ''
      }
      clearTimeout(state.timer);
    },

    // 删除评论
    delCom: () => {
      Dialog.confirm({
        title: "提示",
        message: "确认删除此条评论吗？",
      })
        .then(() => {
          delCommentApi(state.comId).then((res: any) => {
            state.detailData.comments = state.detailData.comments.filter(
              (value: any) => {
                return value.id != state.delId;
              }
            );
            state.comId =state.acDelId = state.delId = "";
            state.is1S = false
          });
        })
        .catch(() => {
          state.comId =state.acDelId = state.delId = "";
            state.is1S = false
        });
    },
    // 去农户详情
    toFarmerDetail: (id: string, type: number) => {
      console.log(id, type);

      let url = "/farmerDetail";
      if (type == 0 || type == 2) {
        url = "/userDetail";
      }
      router.push({
        path: url + "/" + id,
        query: {
          type,
        },
      });
    },
    toFarmerDetailtwo: (item: any, type: number) => {
      console.log(item, type);
      let url = "/farmerDetail";
      let id = item.farmerId;
      if (type == 0 || type == 2) {
        id = item.createUser;
        url = "/userDetail";
      }
      router.push({
        path: url + "/" + id,
        query: {
          type,
        },
      });
    },
    // 去资源页
    toResource(id: string) {
      router.push({
        path: "/resourceDetail/" + id,
      });
    },
  };
};

const useDatas = (state: StateType, replyField: Ref) => {
  const getDetailData = async function (id: string) {
    const result: any = await farmerChatDetailApi(id);
    if (result.data.code === 0) {
      result.data.data.isShow = false;
      result.data.data.videoList.forEach((videos: any) => {
        // 将视频time转为00:00格式
        videos.timeStr = convertSec2Str(videos.time);
      });
      state.detailData = result.data.data;
    }
  };
  return {
    getDetailData,
    onComment: async function () {
      state.showReply = true;
      // 只是评论时清除一下回复数据，避免取到上次的id
      state.replyData = {};
      // 拿到当前评论数据，在提交时需要该数据id
      nextTick(() => {
        state.replyPlaceholder = "评论...";
        replyField.value.focus();
      });
      (state.detailData as { isShow: boolean }).isShow = false;
    },
    onZan: async function () {
      const result: any = await updateZanApi(
        (state.detailData as { id: string }).id
      );
      if (result.data.code === 0) {
        getDetailData(state.recordId);
      }
    },
    onConfirmReply: async function () {
      if (!state.replyMessage) {
        return;
      }
      let param: any = {
        content: state.replyMessage,
        recordId: (state.detailData as { id: "" }).id,
      };
      if (Object.keys(state.replyData).length > 0) {
        param.parentId = state.replyData.id;
      }
      const result: any = await replyChatApi(param);
      if (result.data.code === 0) {
        getDetailData(state.recordId);
        state.replyMessage = "";
        state.replyData = {};
        state.replyPlaceholder = "评论...";
      }
    },
  };
};

// 处理数据
const useOper = (state: StateType) => {
  return {
    getZanText: function (list: Array<any>) {
      return list.map((item) => item.name).join(",");
    },
    transfromDate: function (date: string) {
      let d = date.split(" ")[0];
      return d.replace(/-/gi, ".");
    },
  };
};
